import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Excubia brand lockup: the shield mark from the supplied artwork plus the wordmark set in type
 * so it stays crisp at every size. `onDark` switches the wordmark to a light colour.
 */
const BrandLogo = ({ height = 40, onDark = false, markOnly = false, sx = {}, ...props }) => {
  const fontSize = height * 0.62;
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: `${Math.round(height * 0.15)}px`, lineHeight: 1, ...sx }} {...props}>
      <Box component="img" src={height > 96 ? '/logo512.png' : '/logo192.png'} alt="Excubia" sx={{ height, width: height, display: 'block' }} />
      {!markOnly && (
        <Typography
          component="span"
          aria-hidden="true"
          sx={{ fontSize, fontWeight: 800, letterSpacing: `${-fontSize * 0.02}px`, color: onDark ? '#eceff1' : '#2b2e33', fontFamily: '"Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif', whiteSpace: 'nowrap' }}
        >
          excubia<Box component="span" sx={{ color: '#ff8a00' }}>.io</Box>
        </Typography>
      )}
    </Box>
  );
};

export default BrandLogo;
